module.exports = __webpack_public_path__ + "media/metronic/_theme/media/logos/logo-mini-lg-ae98f13588f9382fc0bbe1ece4a3e289.png";